import { TESTIMONIALS, GOOGLE_RATING, IMG, waLink } from "../data/content";
import { PageHero, Chapter, Reveal, Btn, useTitle } from "../components/shared";
import { WhatsAppIcon } from "../components/Navbar";

const Stars = ({ dimLast = false }) => (
  <div className="flex gap-1 text-gold" data-testid="google-stars">
    {[0, 1, 2, 3, 4].map((i) => (
      <svg key={i} viewBox="0 0 24 24" fill="currentColor" className={`h-5 w-5 ${dimLast && i === 4 ? "opacity-30" : ""}`}>
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
      </svg>
    ))}
  </div>
);

export default function Testimonials() {
  useTitle("Client Testimonials | The Big Wedd");
  return (
    <main>
      <PageHero
        eyebrow="Testimonials"
        title={[<span key="t">Words from <span className="italic text-gold-light">our couples</span></span>]}
        sub="The celebrations speak — and so do the people at the heart of them."
        img={IMG.testimonialsHero}
      />

      <section className="bg-ivory py-24 md:py-32" data-testid="testimonials-section">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <Chapter num="01" title="Client Testimonials" />
          <Reveal delay={0.1}>
            <h2 className="mt-6 max-w-2xl font-serif text-4xl md:text-6xl leading-[1.05] text-emerald">
              Every wedding leaves behind <span className="italic text-gold-text">a story</span>
            </h2>
          </Reveal>

          <div className="mt-14 grid gap-10 md:grid-cols-3">
            {TESTIMONIALS.map((t, i) => (
              <Reveal key={t.couple} delay={i * 0.12}>
                <article className="group h-full border border-gold/25 bg-white/70" data-testid={`testimonial-card-${i}`}>
                  <div className="relative overflow-hidden">
                    <img src={t.img} alt={`${t.couple} wedding`} loading="lazy" className="h-64 w-full object-cover transition-transform duration-[1.6s] group-hover:scale-105" />
                    <span className="absolute left-4 top-4 bg-ivory/90 px-4 py-1.5 text-[10px] uppercase tracking-[0.22em] text-emerald">{t.place}</span>
                  </div>
                  <div className="p-7">
                    <span className="font-serif text-6xl leading-none text-gold">“</span>
                    <p className="mt-2 text-sm md:text-base italic leading-relaxed text-stone2">{t.review}</p>
                    <p className="mt-6 font-serif text-2xl text-emerald">{t.couple}</p>
                    <p className="text-[11px] uppercase tracking-[0.25em] text-gold-text">{t.place}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-emerald-deep py-24 md:py-32" data-testid="google-reviews">
        <div className="mx-auto max-w-7xl px-6 md:px-12 text-center">
          <Chapter num="02" title="Google Reviews" dark center />
          <Reveal delay={0.1}>
            <div className="mt-10 flex flex-col items-center gap-4">
              <p className="font-serif text-7xl md:text-8xl text-ivory" data-testid="google-rating">
                {GOOGLE_RATING.score}<span className="text-gold-light text-4xl md:text-5xl">/{GOOGLE_RATING.outOf}</span>
              </p>
              <Stars dimLast />
              <p className="text-[11px] uppercase tracking-[0.3em] text-gold-light">Google Rating</p>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mx-auto mt-8 max-w-xl text-sm md:text-base leading-relaxed text-ivory/60">
              Verified Google reviews from our couples and their families will be integrated and displayed here — authentic reviews only, updated as they come in.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Btn href="https://www.google.com/search?q=The+Big+Wedd+reviews" external variant="solid" testid="google-reviews-cta">See More Reviews</Btn>
              <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="testimonials-cta-whatsapp" className="inline-flex items-center gap-3 rounded-full border border-ivory/50 px-8 py-4 text-[11px] md:text-xs font-medium uppercase tracking-[0.22em] text-ivory transition-all duration-500 hover:bg-ivory hover:text-emerald">
                <WhatsAppIcon className="h-4 w-4" /> Chat On WhatsApp
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
